// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import AnimValueProgress from "../../../engines/components/animation/AnimValueProgress";
import BaseComponent from "../../../engines/components/BaseComponent";
import O1HD from "../../../engines/gameEngine";
import CsvDataManage from "../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../define/CsvFileKind";
import { GeneralKind } from "../../define/GeneralKind";

const {ccclass, property} = cc._decorator;

@ccclass
export default class LevelInfoNode extends BaseComponent {

	@property({ type: AnimValueProgress, displayName:'' })
	progressLevel: AnimValueProgress = null;

	// @property({ type: cc.Label, displayName:'' })
	// labelLevelName: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelLevelExp: cc.Label = null;

    @property(cc.Node)
    levelNameNode: cc.Node = null;

    
    private labelLevelName: cc.Label = null;
    private sprLevelBg: cc.Sprite = null;
    
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    initUI() {
        if (this.labelLevelName) {
            return;
        }
        this.labelLevelName = cc.find('labelLevelName', 
            this.levelNameNode)?.getComponent(cc.Label);
        this.sprLevelBg = cc.find('sprLevelBg', 
            this.levelNameNode)?.getComponent(cc.Sprite);
    }

    setLevelName(name: string) {
        if (!this.labelLevelName) {
            return;
        }
        this.labelLevelName.string = name;
    }

    refreshLevel(lv: number) {
        this.initUI();
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.LEVEL);
        if (!csvInfos) {
            console.error(`未找到表格数据`);
            return;
        }
        let info = csvInfos[lv];
        if (!info) {
            console.error(`等级表格数据有误`);
            return;
        }
        let title = csvInfos.title;
        this.setLevelName(info[title.level_name]);

        if (this.sprLevelBg) {
            let icon = info[title.icon];
            O1HD.getManagers().gameMgr.getCurrMode().bundle.load(
                `res/user/levelIcon/${icon}`
                , cc.SpriteFrame
                , ( error , assets : cc.SpriteFrame )=>
                {
                    if ( error ) {
                        console.log("图片加载失败");
                        return
                    }
                    this.sprLevelBg.spriteFrame = assets;
                }
            );
        }
        
        if (this.labelLevelName) {
            this.labelLevelName.node.color = lv == GeneralKind.GeneralValue.MAX_LEVEL
                ? new cc.Color(0xb4,0x5a,0x1d) 
                : new cc.Color(0xff,0xfb,0xef);
        }
        
    }

    /**
     * 刷新经验显示
     * @param curExp 当前经验
     * @param totalExp 总经验
     * @param bMax 是否是最顶级
     * @param bPalyAni 是否播放动画
     */
    refreshExp(
        curExp: number
        , totalExp: number
        , bMax: boolean
        , bPalyAni: boolean = false
    ) {
        let progressValue = 1;
        let strExp = 'max';

        if (!bMax) {
            strExp = curExp + '/' + totalExp;
            progressValue = Math.min(curExp / totalExp, 1);
        }
        this.progressLevel.setValue(progressValue, true, bPalyAni);
        this.labelLevelExp.string = strExp;
    }

    // update (dt) {}
}
